/* ==========================================================================
   FOOTBALL-THEME :: Collection pager
   - page size selector (16 / 32 / 48, remembered per browser)
   - page number input + prev/next at the top AND the bottom of the grid
   - sizes above the server page size are stitched from consecutive
     section-rendering fetches (prices, filters and sorting stay accurate)

   The native Dawn pagination stays in the HTML as a no-JS fallback and is
   hidden once this script takes over. Everything re-syncs on filter changes
   ('fs:filters-applied') and on any grid re-render (sort, filter, refresh).
   ========================================================================== */

(function () {
  if (window.__fsPagerBoot) return;
  window.__fsPagerBoot = true;

  var STORE_KEY = 'fs-per-page';
  var PER_OPTIONS = [16, 32, 48];

  var config = null;
  var perPage = 16;
  var pagesPerStep = 1;
  var step = 1;
  var applying = false;

  function readConfig() {
    var row = document.querySelector('[data-fs-pager-row="top"]');
    var gridWrap = document.getElementById('ProductGridContainer');
    if (!row || !gridWrap) return false;
    var sectionId = row.getAttribute('data-section-id');
    if (!sectionId) return false;
    config = {
      serverPer: parseInt(row.getAttribute('data-server-per-page'), 10) || 16,
      sectionId: sectionId,
      gridWrap: gridWrap
    };
    var stored = parseInt(window.localStorage.getItem(STORE_KEY) || '', 10);
    perPage = PER_OPTIONS.indexOf(stored) !== -1 ? stored : PER_OPTIONS[0];
    return true;
  }

  function surfaceMode() {
    var grid = document.getElementById('product-grid');
    if (grid && grid.getAttribute('data-server-per-page') === '250') return true;
    return !!document.querySelector('#ProductGridContainer.fs-surface-mode');
  }

  function refreshConfig() {
    if (!config) return;
    var grid = document.getElementById('product-grid');
    var per = grid ? parseInt(grid.getAttribute('data-server-per-page') || '', 10) : NaN;
    if (!isNaN(per) && per > 0) config.serverPer = per;
  }

  function currentServerPage() {
    var value = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    return value > 0 ? value : 1;
  }

  function syncStep() {
    refreshConfig();
    pagesPerStep = Math.max(1, Math.round(perPage / config.serverPer));
    step = Math.max(1, Math.ceil(currentServerPage() / pagesPerStep));
  }

  function totalProducts() {
    /* Multi-team merge (jerseys) supplies its own union count. */
    if (window.FS && window.FS.multiTeam && window.FS.multiTeam.active()) {
      var mergedTotal = window.FS.multiTeam.total;
      if (mergedTotal) return mergedTotal;
    }
    /* The data attribute is the FILTERED count. On tag-path pages the text
       reads "1,993 of 5,104 products"; the old parser grabbed 5,104 and the
       pager offered pages that do not exist. */
    var count = document.getElementById('ProductCount');
    if (count) {
      var dataCount = parseInt(count.getAttribute('data-product-count') || '', 10);
      if (!isNaN(dataCount)) return dataCount;
    }
    var nodes = document.querySelectorAll(
      '#ProductCount .product-count__text, #ProductCountDesktop .product-count__text, .product-count__text'
    );
    for (var i = 0; i < nodes.length; i++) {
      var text = nodes[i].textContent.replace(/\s+/g, ' ');
      var match = text.match(/([\d,]+)\s+(?:of|products?)/i);
      if (match) return parseInt(match[1].replace(/,/g, ''), 10);
    }
    return 0;
  }

  function totalSteps() {
    var total = totalProducts();
    return total ? Math.max(1, Math.ceil(total / perPage)) : 1;
  }

  function pushUrl() {
    var params = new URLSearchParams(window.location.search);
    var serverPage = (step - 1) * pagesPerStep + 1;
    if (serverPage <= 1) {
      params.delete('page');
    } else {
      params.set('page', serverPage);
    }
    var query = params.toString();
    history.pushState({ fsPager: true }, '', query ? '?' + query : window.location.pathname);
  }

  function fetchPage(pageNumber) {
    /* Multi-team merge (jerseys): return the merged page instead of one tag. */
    if (window.FS && window.FS.multiTeam && window.FS.multiTeam.active()) {
      return window.FS.multiTeam.fetchPage(pageNumber);
    }
    var params = new URLSearchParams(window.location.search);
    if (pageNumber <= 1) {
      params.delete('page');
    } else {
      params.set('page', pageNumber);
    }
    var query = params.toString();
    var url = window.location.pathname + '?section_id=' + config.sectionId + (query ? '&' + query : '');
    return fetch(url).then(function (response) {
      return response.text();
    });
  }

  function load(scrollToGrid) {
    if (applying || !config || surfaceMode()) return;
    applying = true;

    var first = (step - 1) * pagesPerStep + 1;
    var last = step * pagesPerStep;
    var requests = [];
    for (var page = first; page <= last; page++) {
      requests.push(fetchPage(page));
    }

    Promise.all(requests)
      .then(function (pages) {
        var items = '';
        pages.forEach(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.getElementById('product-grid');
          if (!grid) return;
          Array.prototype.forEach.call(grid.children, function (item) {
            items += item.outerHTML;
          });
        });
        var gridEl = document.getElementById('product-grid');
        if (!gridEl || !items) return;
        gridEl.innerHTML = items;
        if (scrollToGrid) {
          config.gridWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function () {})
      .then(function () {
        applying = false;
        render();
      });
  }

  function pagerMarkup(total) {
    var steps = total ? Math.max(1, Math.ceil(total / perPage)) : 1;
    if (step > steps) step = steps;

    var from = (step - 1) * perPage + 1;
    var to = total ? Math.min(step * perPage, total) : step * perPage;

    var perOptions = PER_OPTIONS.map(function (value) {
      return '<option value="' + value + '"' + (value === perPage ? ' selected' : '') + '>' + value + '</option>';
    }).join('');

    var rangeText = total
      ? '<span class="fs-pager__range">' + from.toLocaleString() + '–' + to.toLocaleString() + ' of ' + total.toLocaleString() + '</span>'
      : '';

    return (
      '<label class="fs-pager__field">Show' +
        '<span class="fs-pager__select"><select data-fs-pp aria-label="Products per page">' + perOptions + '</select></span>' +
      '</label>' +
      (steps > 1
        ? '<span class="fs-pager__nav">' +
            '<button type="button" class="fs-pager__btn" data-fs-pg="-1" aria-label="Previous page"' + (step <= 1 ? ' disabled' : '') + '>' +
              '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M14.5 6 8.5 12l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
            '<label class="fs-pager__field">Page' +
              '<input class="fs-pager__input" data-fs-jump-input type="text" inputmode="numeric" value="' + step + '" aria-label="Page number">' +
              '<span class="fs-pager__of">of ' + steps + '</span>' +
            '</label>' +
            '<button type="button" class="fs-pager__btn" data-fs-pg="1" aria-label="Next page"' + (step >= steps ? ' disabled' : '') + '>' +
              '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M9.5 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
          '</span>'
        : '') +
      rangeText
    );
  }

  function render() {
    if (!config) return;
    var markup = pagerMarkup(totalProducts());
    document.querySelectorAll('[data-fs-pager]').forEach(function (el) {
      var input = el.querySelector('[data-fs-jump-input]');
      var focused = input && document.activeElement === input;
      if (focused) return;
      el.innerHTML = markup;
    });

    var sortValue = new URLSearchParams(window.location.search).get('sort_by') || '';
    document.querySelectorAll('[data-fs-sort]').forEach(function (select) {
      if (sortValue && select.value !== sortValue) {
        select.value = sortValue;
      }
    });
  }

  function stepTo(newStep, scrollToGrid) {
    var steps = totalSteps();
    step = Math.min(Math.max(1, newStep), steps);
    pushUrl();
    load(scrollToGrid);
    render();
  }

  document.addEventListener('change', function (event) {
    if (!config) return;
    var perSelect = event.target.closest('[data-fs-pp]');
    if (perSelect) {
      perPage = parseInt(perSelect.value, 10) || PER_OPTIONS[0];
      window.localStorage.setItem(STORE_KEY, String(perPage));
      pagesPerStep = Math.max(1, Math.round(perPage / config.serverPer));
      stepTo(1, false);
      return;
    }

    var sortSelect = event.target.closest('[data-fs-sort]');
    if (sortSelect) {
      var params = new URLSearchParams(window.location.search);
      if (sortSelect.value) {
        params.set('sort_by', sortSelect.value);
      } else {
        params.delete('sort_by');
      }
      params.delete('page');
      var query = params.toString();
      history.pushState({ fsPager: true }, '', query ? '?' + query : window.location.pathname);
      step = 1;
      /* The merged jersey grid re-reads the sort itself; do not let Dawn
         replace it with a single-team grid. */
      if (window.FS && window.FS.multiTeam && window.FS.multiTeam.active()) {
        if (window.FS.multiTeam.clearCache) window.FS.multiTeam.clearCache();
        load(false);
        render();
        return;
      }
      if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
        FacetFiltersForm.renderPage(query, null, true);
        if (window.FS && window.FS.refreshSections) {
          window.FS.refreshSections().then(function () {
            if (window.FS.initTiles) window.FS.initTiles(document);
            if (window.FS.afterRefresh) window.FS.afterRefresh();
          });
        }
      }
      load(false);
      render();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!config) return;
    var input = event.target.closest('[data-fs-jump-input]');
    if (input && event.key === 'Enter') {
      event.preventDefault();
      stepTo(parseInt(input.value, 10) || 1, true);
    }
  });

  document.addEventListener('focusout', function (event) {
    if (!config) return;
    if (event.target.closest('[data-fs-jump-input]')) {
      render();
    }
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fs-pg]');
    if (btn && config) {
      stepTo(step + parseInt(btn.getAttribute('data-fs-pg'), 10), true);
    }
  });

  window.addEventListener('popstate', function () {
    if (!config) return;
    syncStep();
    if (!surfaceMode()) load(false);
    render();
  });

  /* Filters re-render the grid through Dawn or the tile script. */
  document.addEventListener('fs:filters-applied', function () {
    if (!config) return;
    syncStep();
    if (!surfaceMode()) load(false);
    render();
  });

  /* The dock swaps the grid in place on tag-path navigation. Re-sync the
     pager against the new URL/count without a full page load. */
  window.FS = window.FS || {};
  window.FS.pagerRefresh = function () {
    if (!config) return;
    syncStep();
    render();
  };
  window.FS.pagerLoad = load;

  /* Any other grid re-render (sort dropdown, native filters, refresh). */
  function watchGrid() {
    if (!config.gridWrap || !window.MutationObserver) return;
    var timer;
    new MutationObserver(function () {
      if (applying) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        syncStep();
        if (surfaceMode()) {
          render();
          return;
        }
        load(false);
        render();
      }, 150);
    }).observe(config.gridWrap, { childList: true, subtree: true });
  }

  function boot() {
    if (!readConfig()) return;
    document.documentElement.classList.add('fs-pager-on');
    syncStep();
    render();
    watchGrid();
    if (surfaceMode()) return;
    if (pagesPerStep > 1 || step > 1 || (window.FS && window.FS.multiTeam && window.FS.multiTeam.active())) {
      load(false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
